// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../variables.css\"","breakpoint":"768px","prompt":"Prompt_prompt__2vQFq","pulse":"Prompt_pulse__3_8Ld"};